import { findInArray, getProjectTasksParentFolderId } from 'owa-timestream-asset-sdk';
import { todoCache, createFolderIdDescriptor, updateSubtodo } from 'owa-timestream-asset-sdk-tasks';
import { getSubtodoPropertiesForInsert } from 'owa-todo-utils';
import type { ProjectId } from 'owa-timestream-types';

export default function handleSubtaskShift(
    projectId: ProjectId,
    parentTaskId: string,
    draggedSubtaskId: string,
    isShiftedDown: boolean
): void {
    const subtasks = todoCache.getTaskForLock(
        parentTaskId,
        createFolderIdDescriptor(getProjectTasksParentFolderId(projectId))
    )?.Subtasks;
    if (!subtasks) {
        return;
    }

    const subtaskIndex = findInArray(subtasks, subtask => subtask.Id === draggedSubtaskId)?.index;

    if (subtaskIndex === undefined || subtaskIndex === null) {
        return;
    }

    // shifting down, the target index should be +2
    // as getPropertiesForInsert assumes we want to go before, not after
    // in the case of where the target index is at the end of the subtasks
    // target index should be set to length to force the case in getPropertiesForInsert to move it to the end
    const targetIndex = isShiftedDown
        ? subtaskIndex == subtasks.length - 1
            ? subtasks.length
            : subtaskIndex + 2
        : subtaskIndex - 1;

    if (targetIndex === -1) {
        return;
    }

    const subtodoUpdates = getSubtodoPropertiesForInsert(targetIndex, subtasks);
    updateSubtodo(subtodoUpdates, parentTaskId, draggedSubtaskId);
}
